<template>
    <v-dialog
        v-model="dialog"
        max-width="700"
        scrollable
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                depressed
                color="blue"
                small
                class="ma-2 white--text"
                v-bind="attrs"
                v-on="on"
            >
                {{ $t('module.impression') }}
                <v-icon right>mdi-state-machine</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar flat height="40" color="blue">
                <v-toolbar-title class="white--text">Etats</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-expansion-panels
                        v-model="panelModel"
                        dense
                        focusable
                    >
                        <v-expansion-panel
                            v-for="(model, index) in models"
                            :key="`model-${index}`"
                        >
                            <v-expansion-panel-header>
                                <strong>{{ model.title }}</strong>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="mr-n5 ml-n5">
                                <v-container fluid>
                                    <v-list dense>
                                        <template v-for="(item, indey) in model.children">
                                            <v-divider
                                                :key="`d-item-${indey}-${index}`"
                                                v-if="item.divider"
                                            />
                                            <v-list-item
                                                :key="`item-${indey}-${index}`"
                                                v-else
                                                @click="goTo(item.route)"
                                            >
                                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {ref} from "vue";
import useTools from "@/use/Tools";

export default {
    name: "ImpressionModels",
    setup() {
        const {$router, $i18n} = useTools();
        const dialog = ref(false);
        const panelModel = ref(0);
        const models = ref([
            {
                title: $i18n.t('impression.contribution_cnas_irg_cacobath'), children: [
                    {title: $i18n.t('module.DECLARATION_COTISATION'), route: "declaration_cotisation"},
                    {title: $i18n.t('module.DECLARATION_COTISATION_OLD'), route: "declaration_cotisation_old"},
                    {title: $i18n.t('module.mouvement_personnel'), route: "mouvement_personnel"},
                    {title: $i18n.t('module.verification_caisses'), route: "verification_caisses"},
                    
                    {divider: true},
                    {title: $i18n.t('module.cnas_declaration_annuelle'), route: "cnas_declaration_annuelle"},
                    // {title: "CNAS - Exploiter les 2 Fichiers d'une DAS", route: ""},
                    
                    {divider: true},
                    {title: $i18n.t('module.declaration_irg_301_bis'), route: "declaration_irg_301_bis"},
                    
                    {divider: true},
                    {title: $i18n.t('module.DECLARATION_COTISATION_CACOBATH'), route: "declaration_cotisation_cacobath"},
                    // {title: "CACOBATH - Déclaration Annuelle des Congés", route: ""},
                    // {title: "CACOBATH - Déclaration Nominative Mensuelle", route: ""},
                    
                    {divider: true},
                    // {title: "Génération Ficher Mutuelle", route: ""},
                ]
            },
        ]);
        
        function goTo(route) {
            $router.push({name: route});
            dialog.value = false;
        }
        
        return {
            dialog,
            panelModel,
            models,
            goTo
        }
    }
}
</script>

<style scoped>

</style>